var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('header-name',[_vm._v("Add Stock")]),_vm._v(" "),_c('add-stock-form',{attrs:{"product-search-route-name":"add-stock.search","change-stock-route-name":"add-stock.change","add-stock-route-name":"add-stock.add","get-stock-levels-route-name":"add-stock.stock-level"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }